export const iconFontAwesomeMapsTruck = (
	<i className="fa-solid fa-truck"></i>
);
